var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10370",
    "data-name": "Group 10370",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.942,
    height: 96.148,
    viewBox: "0 0 99.942 96.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2247",
    "data-name": "Rectangle 2247",
    width: 99.942,
    height: 96.148,
    fill: "#ffbd00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10367",
    "data-name": "Group 10367",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27735",
    "data-name": "Path 27735",
    d: "M40.806,6.559l-5.238,16.5a9.4,9.4,0,0,1-8.9,6.56L9.36,29.732A9.407,9.407,0,0,0,3.947,46.786L18.017,56.863a9.408,9.408,0,0,1,3.489,10.494l-5.237,16.5A9.406,9.406,0,0,0,30.814,94.271L44.747,84A9.4,9.4,0,0,1,55.8,83.929L69.874,94.006a9.406,9.406,0,0,0,14.4-10.614L78.819,66.969a9.4,9.4,0,0,1,3.345-10.54L96.1,46.162a9.407,9.407,0,0,0-5.645-16.979L73.146,29.3a9.4,9.4,0,0,1-8.99-6.438L58.7,6.438a9.407,9.407,0,0,0-17.892.121",
    transform: "translate(0 0)",
    fill: "#ffbd00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgStar);
export default __webpack_public_path__ + "static/media/bg_star.20148d5b8bbf2ddecec1b38aed187ecc.svg";
export { ForwardRef as ReactComponent };